<template>
  <form @submit.prevent="formDocsAction" v-if="acessoId" class="mb-4">
      <b-field horizontal label="Documentos">
        <b-field label="Tipo Documento">
          <b-select
            v-model="formDocs.tipo"
            placeholder="Selecionar Tipo Documento"
            required
            expanded
          >
            <option
              v-for="(tipo, index) in tiposDoc"
              :key="index"
              :value="tipo.valor"
            >
              {{ tipo.label }}
            </option>
          </b-select>
        </b-field>

        <b-field label="Data Documento">
          <input
            type="date"
            v-model="formDocs.data"
            class="input"
            pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
          />
        </b-field>

        <b-field label="Documento">
          <file-picker
            v-model="formDocs.file"
            type="is-info"
            :required="true"
          />
        </b-field>
      </b-field>

      <br />

      <b-field horizontal>
        <b-field>
          <div class="control">
            <b-button native-type="submit" type="is-info" :loading="isLoading">
              Enviar
            </b-button>
          </div>
        </b-field>
      </b-field>

      <br />

      <b-field horizontal>
        <b-table
          :data="documentos"
          striped
          hoverable
          style="border: 1px solid rgb(225, 225, 225)"
        >
          <b-table-column v-slot="doc" label="Tipo Documento" field="tipo">
            {{ doc.row.tipo }}
          </b-table-column>

          <b-table-column v-slot="doc" label="Data do Documento" field="data">
            {{ doc.row.data }}
          </b-table-column>

          <b-table-column v-slot="doc" label="Data de expiração" field="dataExpiracao">
            {{ doc.row.dataExpiracao || "N/A" }}
          </b-table-column>

          <b-table-column
            v-slot="doc"
            label="Ações"
            custom-key="actions"
            cell-class="is-actions-cell"
            :width="100"
          >
            <div
              class="buttons is-right no-wrap"
              style="display: flex; justify-content: center"
            >
              <b-tooltip label="Excluir" type="is-light">
                <b-button
                  type="is-danger"
                  size="is-small"
                  @click="confirmarDeleteDoc(doc.row)"
                >
                  <b-icon icon="trash-can" size="is-small" />
                </b-button>
              </b-tooltip>

              <b-tooltip label="Baixar Documento" type="is-light">
                <b-button
                  type="is-success"
                  size="is-small"
                  @click="downloadDocumento(doc.row)"
                  download
                >
                  <b-icon icon="download" size="is-small" />
                </b-button>
              </b-tooltip>
            </div>
          </b-table-column>

          <section slot="empty" class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large" />
              </p>
              <p>Não há dados&hellip;</p>
            </div>
          </section>
        </b-table>
      </b-field>
      </form>
</template>

<script>
import { defineComponent } from "vue";

import FilePicker from "../FilePicker.vue";
import CardComponent from "../Cards/CardComponent.vue";
import DocumentoService from "@/services/DocumentoService.js";

export default defineComponent({
  name: "FormDocumentos",
  components: {
    FilePicker,
    CardComponent,
  },
  props: {
    acessoId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      formDocs: {
        file: null,
        data: null,
        tipo: null,
        idAcessoPessoa: null, // Inicialize como null
        
      },
      isLoading: false,
      documentos: [],
      tiposDoc: [
        {
          label: "Comprovante de Vacina",
          valor: "COMPROVANTE_VACINA",
        },
        {
          label: "PROAPI",
          valor: "PROAPI",
        },
        {
          label: "ASO",
          valor: "ASO",
        },
        {
          label: "MOPP / CNH Digital",
          valor: "CNH_MOPP",
        },
      ],
    };
  },
  mounted() {
    const id = this.acessoId ?? this.$route.params.id;
    if (id) {
      this.formDocs.idAcessoPessoa = id; // Defina o idAcessoPessoa aqui
      this.retrive(id);
    } else {
      this.$buefy.toast.open({
        message: "Erro: ID do acesso não encontrado!",
        position: "is-bottom",
        type: "is-danger",
      });
    }
  },
  methods: {
    confirmarDeleteDoc(item) {
      this.$buefy.dialog.confirm({
        title: "Excluir Documento ?",
        message: `Tem certeza de que deseja <b>excluir</b> esse documento <b>( ${item.tipo} )</b> ? Essa ação não poderá ser desfeita`,
        confirmText: "Excluir Documento",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.deletarDocumento(item.id),
      });
    },

    deletarDocumento(id) {
      DocumentoService.deleteDocumento(id)
        .then(() => {
          this.$buefy.toast.open({
            message: `Documento deletado!`,
            position: "is-bottom",
            type: "is-info",
          });
          location.reload();
        })
        .catch((error) => {
          this.$buefy.toast.open({
            message: `Houve algum problema ao deletar o documento`,
            position: "is-bottom",
            type: "is-danger",
          });
          console.error(error);
        });
    },
    async formDocsAction() {
      if (!this.validarDoc()) {
        return;
      }

      // Certifique-se de que idAcessoPessoa está definido
      if (!this.formDocs.idAcessoPessoa) {
        const id = this.acessoId ?? this.$route.params.id;
        if (id) {
          this.formDocs.idAcessoPessoa = id;
        } else {
          this.$buefy.toast.open({
            message: "Erro: ID do acesso não encontrado!",
            position: "is-bottom",
            type: "is-danger",
          });
          return;
        }
      }

      try {
        this.isLoading = true;

        await DocumentoService.postDocumento(this.formDocs);

        this.$buefy.toast.open({
          message: "Documentos Enviado com Sucesso!",
          position: "is-bottom",
          type: "is-success",
        });

        location.reload();
      } catch (error) {
        this.$buefy.toast.open({
          message: error.response?.data?.message ?? "Erro ao enviar documento!",
          position: "is-bottom",
          type: "is-danger",
        });
        console.error("Erro ao enviar documentos:", error);
      } finally {
        this.isLoading = false;
      }
    },
    validarDoc() {
      if (!this.formDocs.data) {
        this.$buefy.toast.open({
          message: "Erro, por favor preencha a Data corretamente!",
          position: "is-bottom",
          type: "is-danger",
        });
        return false;
      } else {
        if (this.formDocs.data > new Date()) {
          this.$buefy.toast.open({
            message: "Erro, Data informada maior que data atual",
            position: "is-bottom",
            type: "is-danger",
          });
          return false;
        }
      }

      return true;
    },

    downloadDocumento(item) {
      DocumentoService.baixarDoc(item.nomeArquivo).then((result) => {
        const blob = new Blob([result.data]);
        let url = window.URL.createObjectURL(blob);

        let extensao = item.nomeArquivo.split(".").pop();
        let nomeDoc = `doc-${item.tipo}.${extensao}`;

        const link = document.createElement("a");
        link.href = url;
        link.download = nomeDoc;
        link.click();

        window.URL.revokeObjectURL(url);
      });
    },
    async retrive(id) {
      try {
        DocumentoService.getDocumentosAcesso(id).then((result) => {
          console.log("result:", result);
          this.documentos = result.data;
          if(this.documentos.length === 0) {
            this.$emit("no-docs")
            this.$buefy.toast.open({
              message: "Nenhum documento encontrado!",
              position: "is-bottom",
              type: "is-info",
            });
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
});
</script>

<style>
.qr-code-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
}

.qr-code {
  width: 300px;
  height: 300px;
  object-fit: contain;
}
</style>
